import { render, staticRenderFns } from "./checkboxes-boolean.vue?vue&type=template&id=63a75bfb&"
import script from "./checkboxes-boolean.vue?vue&type=script&lang=js&"
export * from "./checkboxes-boolean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VContainer})
